import React from "react";

import { withResolvePaths } from "../../withResolvePaths";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { useMultilineClient } from "../../../Engine/Core/Filtering/UseMultilineClient";
import { createHocDisplayName } from "../../TypingUtils";

import { MultiLineSidebar } from "./MultiLineSidebar";

interface MultiLineSidebarContainerProps {
    bindingPath: AbsoluteResolvedModelPath;
    filteredUniqKey?: string;
    isList: boolean;
}

const MultiLineSidebarWrapper: React.FC<MultiLineSidebarContainerProps> = ownProps => {
    const { bindingPath, filteredUniqKey = "default", children } = ownProps;

    const { currentPage, instancesPerPage, displayedInstances } = useMultilineClient(
        bindingPath,
        filteredUniqKey,
        info => ({
            currentPage: info.multilineState.currentPage,
            displayedInstances: info.multilineState.displayedInstances,
            instancesPerPage: info.multilineState.instancesPerPage,
        })
    );

    return (
        <MultiLineSidebar
            {...ownProps}
            currentPage={currentPage}
            instancesPerPage={instancesPerPage}
            displayedInstances={displayedInstances}>
            {children}
        </MultiLineSidebar>
    );
};

MultiLineSidebarWrapper.displayName = createHocDisplayName(MultiLineSidebar, "MultiLineSidebarWrapper");

export const MultiLineSidebarContainer = withResolvePaths(MultiLineSidebarWrapper);
